import React, { useEffect, useState } from 'react';
import './style.scss';

const Radio = ({ selectedOption, value, onChange, colorRadio }) => {
  return (
    <div className="radio" key={value} onClick={() => onChange(value)}>
      <input
        type='radio'
        value={value}
        checked={selectedOption.toString() === value.toString()}
        onChange={() => onChange(value)}
      />
      <span className={`checkmark ${colorRadio ? 'color-radio' : ''}`} />
    </div>
  )
}

const SlideWrapper = ({ list, child: Child, numberMobile, numberPC, colorRadio, onClick }) => {
  const [listDesktop, setListDesktop] = useState([]);
  const [listMobile, setListMobile] = useState([]);
  const [radioDesktop, setRadioDesktop] = useState([]);
  const [radioMobile, setRadioMobile] = useState([]);
  const [selectedRadio, setSelectedRadio] = useState(0);

  useEffect(() => {
    const listAppPC = convertedListApp(0, numberPC, list);
    const listAppMobile = convertedListApp(0, numberMobile, list);
    setListDesktop(listAppPC);
    setListMobile(listAppMobile);

    const listRadioPC = getListRadio(numberPC, list.length);
    const listRadioMobile = getListRadio(numberMobile, list.length);
    setRadioDesktop(listRadioPC);
    setRadioMobile(listRadioMobile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list.length]);

  const getListRadio = (number, length) => {
    const list = [];
    const lengthList = Math.ceil(length / number);
    for (let i = 0; i < lengthList; i++) {
      list.push(i);
    }
    return list;
  }

  const convertedListApp = (index, number, list) => {
    const newList = [];
    for (let i = index * number; i < list.length && i < (index + 1) * number; i++) {
      newList.push(list[i])
    }
    return newList;
  }

  const handleSelectRadio = (index, number) => {
    setSelectedRadio(index);
    const newList = convertedListApp(index, number, list);
    if (number === numberPC) {
      setListDesktop(newList);
    } else {
      setListMobile(newList);
    }
  }

  if (list.length === 0) {
    return null;
  }

  return (
    <div className="slide-container">
      <div className="d-none d-lg-block">
        <div className="slide-container__list">
          {listDesktop.map((item, index) => (
            <Child item={item} key={index} onClick={() => onClick(item)} />
          ))}
        </div>

        {radioDesktop.length > 1 &&
          <div className="radio-wrapper">
            {radioDesktop.map((number, key) => (
              <Radio
                key={key}
                value={number}
                onChange={(value) => handleSelectRadio(value, numberPC)}
                selectedOption={selectedRadio}
                colorRadio={colorRadio}
              />
            ))}
          </div>
        }
      </div>

      <div className="d-lg-none">
        <div className="slide-container__list">
          {listMobile.map((item, index) => (
            <Child item={item} key={index} onClick={() => onClick(item)} />
          ))}
        </div>

        {radioMobile.length > 1 &&
          <div className="radio-wrapper">
            {radioMobile.map((number, key) => (
              <Radio
                key={key}
                value={number}
                onChange={(value) => handleSelectRadio(value, numberMobile)}
                selectedOption={selectedRadio}
                colorRadio={colorRadio}
              />
            ))}
          </div>
        }
      </div>
    </div>
  )
}

SlideWrapper.defaultProps = {
  list: [],
  numberMobile: 2,
  numberPC: 4
};

export default React.memo(SlideWrapper);
